import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import enTranslation from '@/locales/en/en.json';
import mmTranslation from '@/locales/mm/mm.json';
import thTranslation from '@/locales/th/th.json';
import { LANGUAGE_KEY } from '@/config/app';

declare global {
  interface Window {
    setAppLanguage: (lang: string) => void;
  }
}

window.setAppLanguage = (lang) => {
  localStorage.setItem(LANGUAGE_KEY, lang);
  i18n.changeLanguage(lang);
};

function getLangFromSearch() {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    if (lang) {
      localStorage.setItem(LANGUAGE_KEY, lang);
      return lang;
    }
  }
  return null;
}

const getInitialLanguage = () => {
  const langFromSearch = getLangFromSearch();
  if (langFromSearch) return langFromSearch;

  if (typeof window !== 'undefined') {
    const savedLanguage = localStorage.getItem(LANGUAGE_KEY);
    return savedLanguage || 'en';
  }
  return 'en';
};

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: { translation: enTranslation },
    my: { translation: mmTranslation },
    th: { translation: thTranslation },
  },
});

export default i18n;
